import StarSvg from '@assets/images/svg/star.svg';
import React from 'react';
import { View } from 'react-native';

export interface StarIconProps {
    size?: number;
    color?: string;
}

export const StarIcon = React.memo<StarIconProps>(function StarIcon({
    size = 24,
    color = '#333333',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <StarSvg width={size} height={size} color={color} />
        </View>
    );
});

export default StarIcon;


